import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

import * as Styles from '../Icon.module.scss';

export const UploadIcon = ({ size = 'medium' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles['dsgGreen'], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            className={fillStyle}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <circle className={fillStyle} cx="20" cy="20" r="20"></circle>
                    <line
                        x1="20.5"
                        y1="12"
                        x2="20.5"
                        y2="30"
                        id="Line-3"
                        stroke="#FFFFFF"
                        strokeWidth="2"
                        strokeLinecap="round"
                    ></line>
                    <polyline
                        id="Path-2"
                        stroke="#FFFFFF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        points="27.1004314 16.8306751 20.5 10.2302437 13.8995686 16.8306751"
                    ></polyline>
                </g>
            </g>
        </svg>
    );
};
